"use client";
import classNames from "classnames";
import { PulseLoader } from "react-spinners";
import { motion } from "framer-motion";

type Props = {
  type?: "submit" | "button";
  className?: string;
  loading?: boolean;
  id?: string;
  onClick?: (e?: any) => void;
  children: React.ReactNode;
  disabled?: boolean;
  loaderColor?: string;
  title?: string;
};

export const Button = ({
  children,
  type,
  className,
  id,
  loading,
  onClick,
  disabled,
  loaderColor = "white",
  title,
}: Props) => {
  return (
    <motion.button
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 1.03 }}
      type={type ?? "button"}
      className={classNames(
        ` ${
          loading || disabled ? "bg-disabled cursor-not-allowed " : ""
        } text-center  rounded-lg whitespace-nowrap ${className} `
      )}
      id={id}
      onClick={onClick}
      disabled={loading || disabled}
      title={title}
    >
      {loading ? <PulseLoader loading={true} color={loaderColor} /> : children}
    </motion.button>
  );
};
